import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss']
})
export class ContentHeaderComponent implements OnInit {
  @Input() headline: string = '';
  @Input() showBackButton: boolean = false;
  @Input() showEditButton: boolean = false;
  @Input() routerLink: string[] | string = '';
  @Input() editRouterLink: string[] | string = '';
  @Output() clickEvent = new EventEmitter();
  @Output() editClickEvent = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  forwardClickEvent() {
    this.clickEvent.emit();
  }

  forwardEditClickEvent() {
    this.editClickEvent.emit();
  }
}
